import Box from '@mui/material/Box';
import List from '@mui/material/List';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ElementType, ReactNode } from 'react';

import { ListSecondaryTextIcon } from '../ListSecondaryTextIcon/ListSecondaryTextIcon';
import { ListSectionItem } from '../ListSectionItem/ListSectionItem';
import { ListSectionItemText } from '../ListSectionItemText/ListSectionItemText';

interface Props {
  title: ReactNode;
  icon: ElementType;

  children: ReactNode;
}
export const ListSection = ({ title, children, icon: Icon }: Props) => (
  <div>
    <Stack
      direction="row"
      sx={{
        alignItems: 'baseline',
        my: 1,
      }}
    >
      <Box
        sx={{
          mr: 0.5,
        }}
      >
        <Icon fontSize="medium" />
      </Box>
      <Typography variant="h4">{title}</Typography>
    </Stack>

    <List disablePadding={true}>{children}</List>
  </div>
);

ListSection.Item = ListSectionItem;
ListSection.ListSecondaryTextIcon = ListSecondaryTextIcon;
ListSection.ItemText = ListSectionItemText;
